import React from 'react'
import classNames from 'classnames'

import style from './PageHeader.module.css'

export default function PageHeader({
  navbar,
  title,
  subtitle,
  className,
  handleLink = false,
}) {
  return (
    <header
      className={classNames(style.pageHeader, 'js-page-header', className)}
    >
      <div className={style.content}>
        {navbar}
        <h1 className={`${style.title} js-page-header-title`}>{title}</h1>
        <p className={`${style.subtitle} js-page-header-subtitle`}>
          {subtitle}
        </p>
        {handleLink && (
          <button
            onClick={handleLink}
            className={`${style.link} zb-button-link js-changes-90-details-link`}
          >
            Changes to account information connections
          </button>
        )}
      </div>
    </header>
  )
}
